module.exports = __webpack_public_path__ + "static/psych-web-9a6ad25cdfd5fa5c4d43b0a5faece107.jpg";